export default (v, a = 100) => {
    return Math.round(v * a) / a
}